import { useState, useEffect, useMemo } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import Form3 from './new-analysis/Form3';
import { loadMatrix, getOrder, getAvailableAnalyses,loadPurchaseOrder } from '../utilities/httpRequest';
import { useNavigate, useLocation } from 'react-router-dom';
import TextButton from '../components/TextButton';
import { Send } from 'lucide-react';
import { computeCost, setAnalysesStatus, setFalseBilansStatus, setBilansStatus, atLeastOneAnalyse, fillAnalyses,fillBilans,fillCommentsAnalyses,fillCommentsBilans } from '../utilities/utils';
import Cookies from 'js-cookie';
import AlertWindow from '../components/AlertWindow';

export default function ModifyOrder() {

    const navigate = useNavigate();
    const [alertWindowText, setAlertWindowText] = useState("");
    const [displayAlertWindow, setDisplayAlertWindow] = useState(false);

    //Récupération du numéro de dossier 
    const location = useLocation();
    const queries = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const orderId = queries.get('order') || "";
    if (!orderId) {
        navigate("*")
    }

    //Chargement des données
    const [order, setOrder] = useState({})
    const [analyses, setAnalyses] = useState([]);
    const [bilans, setBilans] = useState([]);
    useEffect(() => {
        const fetch = async () => {
            const loadingElement = document.getElementById("loading");
            if (loadingElement) loadingElement.style.display = "flex";
            const orderTmp = await getOrder(orderId, navigate)
            const { availableAnalysesData, availableBilansData } = await getAvailableAnalyses(orderTmp.animals[0].species, orderId, navigate)
            let wrapper = { analyses: availableAnalysesData, bilans: availableBilansData }

            //Marquer les analyses commandées précédemment et également les sous analyses

            const customSet = (key) => (updater) => {
                if (typeof updater === 'function') {
                    wrapper[key] = updater(wrapper[key])
                } else {
                    wrapper[key] = updater
                }
            }
            setAnalysesStatus(orderTmp.analyses, customSet("analyses"), "already_ordered", true)
            setFalseBilansStatus(orderTmp.analyse_groups, customSet("analyses"), "already_ordered", true)
            setBilansStatus(orderTmp.bilans, customSet("bilans"), "already_ordered", true)

            setOrder(orderTmp)
            setAnalyses(wrapper.analyses)
            setBilans(wrapper.bilans)
            document.getElementById("loading").style.display = "none";
        }
        fetch()
    }, [orderId,navigate])

    const [cost, setCost] = useState(0);
    useEffect(() => {
        const newCost = computeCost(analyses, bilans)
        setCost(newCost)
    }, [analyses, bilans, setCost]);

    const [matrix, setMatrix] = useState([""]);
    useEffect(() => { loadMatrix(setMatrix, navigate) }, [navigate, setMatrix]);

    const newSubmit = () => {
        
        if(!atLeastOneAnalyse(analyses,bilans)){
            window.alert("Selectionnez au minimum une analyse pour continuer.")
        } else {
            const json = {
                analyses: fillAnalyses(analyses),
                bilans: fillBilans(analyses,bilans),
                infos: {
                    comments_analyses: fillCommentsAnalyses(analyses),
                    comments_bilans: fillCommentsBilans(analyses)
                }
            }
            const xhttp = new XMLHttpRequest();
            document.getElementById("loading").style.display = "flex";
            xhttp.onload = function () {
                if (xhttp.status >= 200 && xhttp.status < 300) {
                    document.getElementById("loading").style.display = "none";
                    let text = "La demande de prescription supplémentaire a été transmise avec succès. En cas d’anomalie (prélèvement insuffisant, échantillons périmés, etc.), notre équipe se rapprochera de vous dans les plus brefs délais.";
                    setAlertWindowText(text);
                    setDisplayAlertWindow(true);
                } else {
                    document.getElementById("loading").style.display = "none";
                    window.alert(this.responseText);
                }
            }
            xhttp.open("PUT", process.env.REACT_APP_API_URL + `order/${order.id}/`);
            xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
            xhttp.send(JSON.stringify(json));
        }
    }

    const loadPrescription = () => {
        document.getElementById("loading").style.display = "flex";
        setTimeout(()=>{
            loadPurchaseOrder(order?.id, navigate)
            document.getElementById("loading").style.display = "none";
        },5000)
    }

    return (
        <>
            <AlertWindow msg={alertWindowText} links={[{ href: loadPrescription, txt: "Télécharger la prescription" },{ href: ()=>setDisplayAlertWindow(false), txt: "Fermer" }]} display={displayAlertWindow} />
            <div className="flex flex-col items-center py-3 gap-3">
                <div className="box-container flex flex-wrap flex-row gap-10 p-3 mx-5 max-w-[1140px]">
                    <div><p className="font-medium text-md text-dark-green">Date de la demande:</p><p>{order?.created_at}</p></div>
                    <div><p className="font-medium text-md text-dark-green">Nom du propiétaire:</p><p>{order?.owner?.first_name} {order?.owner?.last_name}</p></div>
                    <div><p className="font-medium text-md text-dark-green">Nom de l'animal:</p><p>{order?.animals?.[0]?.name}</p></div>
                    <TextButton className="text-lg" lucideIcon={<Send className="text-medium-green group-hover:text-white" />} text="Envoyer les analyses supplémentaires" onClick={newSubmit} />
                </div>
                <Form3 hidden={false} cost={cost} specieId={order?.animals?.[0].species} analyses={analyses} setAnalyses={setAnalyses} matrix={matrix} setMatrix={setMatrix} bilans={bilans} setBilans={setBilans} />
            </div>
        </>

    )
}